<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3>Revoke Invitation</h3>
</div>

<div class="modal-body clearfix">
  <div class="row session-row" *ngFor="let session of revokableSessions">
    <div class="col-lg-6">
      {{ session.config.title }}
    </div>
    <div class="col-lg-6">
      <small *ngIf="!session.canRevoke">
        You can't revoke this invitation, because someone invited this person
        with a stronger role.
      </small>
      <button
        *ngIf="session.canRevoke"
        class="btn btn-danger"
        (click)="revoke(session)">
        Revoke Invitation
      </button>
    </div>
  </div>
</div>
